export default __webpack_public_path__ + "static/weiboCode-db59ec90a62e62c04f17e5a90c50fa1d.png";